import React from "react";
import AttachmentContent from "./attachment-content.jsx";
import ActivitiesContent from "./activities-content.jsx";
import ScheduleGarrisonUtils from "../utils/schedulegarrison-utils.jsx";

const CreateContent = ({ element }) => {
    let createData;

    try {
        createData = typeof element?.details === "string" ? JSON.parse(element.details) : element?.details ?? {};
    } catch {
        createData = {};
    }

    const attachments = createData.attachment;
    const activities = createData.activities;
    const group = createData.garrison_group ?? {};

    const hasContent = ScheduleGarrisonUtils.hasVisibleFields(createData);
    if (!hasContent) return;

    return (
        <tr className="create-content-table">
            <td colSpan={14}>
                <table className="applied insider w-full">
                    <thead>
                        <tr className="text-left">
                            <th style={{ width: "30%" }}>Campo</th>
                            <th style={{ width: "70%" }}>Novo</th>
                        </tr>
                    </thead>

                    <tbody>
                        <ScheduleGarrisonUtils.Row
                            label="Nome"
                            value={createData.name}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Cadastro"
                            value={element.date_time}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Período disponível"
                            value={ScheduleGarrisonUtils.formatPeriod(
                                createData.date_usage_min,
                                createData.date_usage_max
                            )}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Descrição"
                            value={createData.description}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Inativar"
                            value={createData.inactive}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Motivo da inativação"
                            value={createData.inactive_observation}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Dias da semana"
                            value={ScheduleGarrisonUtils.formatWeekdays(group.weekdays)}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Equipe"
                            value={ScheduleGarrisonUtils.formatArray(group.teams)}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Função destinada"
                            value={ScheduleGarrisonUtils.formatGroupFunctions(group.intendedFunctions)}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Setor"
                            value={ScheduleGarrisonUtils.formatArray(group.sectors)}
                        />

                        <ScheduleGarrisonUtils.Row
                            label="Atribuir automaticamente às guarnições"
                            value={createData.auto_apply_by_group}
                        />

                        { activities && (
                            <ActivitiesContent
                                activities={activities}
                            />
                        )}

                        { attachments && (
                            <AttachmentContent
                                attachments={attachments}
                            />
                        )}
                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default CreateContent;